import { app } from "@/main";
import router from "@/router";
import { AxiosError } from "axios";
import { Exceptions, Messages } from "./messages.util";
import { ToastFactory } from "./toast-factory.util";
import { clearStorage } from "./user-store.util";

export default class HandleError {
  async getErrors(error: AxiosError) {
    const errResponse = (error.response as any)?.data;
    switch (error.response?.status) {
      case 400:
        this.renderToastError(errResponse);
        break;
      case 401:
        router.push({ name: "sign-in" });
        this.renderToastError("ERR_BAD_REQUEST");
        return await clearStorage();
      case 415:
        this.renderToastError("ERR_MEDIA_TYPE");
        break;
      default:
        return Promise.reject(error);
    }

    return Promise.reject(error);
  }

  renderToastError(error: any): void {
    if (!error.restErrors) {
      if (error.code !== String(Exceptions[error.code])) {
        app.config.globalProperties.$toast.add(
          ToastFactory.error(this.getMessage(error.code ?? error))
        );
      }
    } else {
      if (error.code !== String(Exceptions[error.code])) {
        error?.restErrors?.forEach((err) => {
          app.config.globalProperties.$toast.add(
            ToastFactory.error(this.getMessage(err?.field))
          );
        });
      }
    }
  }

  getMessage(code: string): string {
    return Messages[code] ?? Messages.GENERIC_ERROR;
  }
}
